import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/leaflypackaging-com/images/menu-list-icon.svg")